import PerformingAssetsCard from "../components/PerformingAssetsCard";
import { META } from "../../../../../utils/constants";
import { PLATFORMS_PLACEHOLDER } from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import {
  DemographicInsightsGrid,
  getPublisherPlatformRowLabel,
} from "./MetaDemographicInsightsTables";

const MetaPublisherPlatformInsightsCard = ({
  publisherPlatformRows = [],
  getCostByMainCurrency,
  sx = {},
}) => {
  const { t } = useTranslationApp();

  if (!publisherPlatformRows?.length) return null;

  return (
    <PerformingAssetsCard
      platform={META}
      title={t(PLATFORMS_PLACEHOLDER)}
      previousContent={
        <DemographicInsightsGrid
          title=""
          rows={publisherPlatformRows}
          getRowLabel={(row) =>
            getPublisherPlatformRowLabel({
              publisherPlatform: row?.publisherPlatform,
              t,
            })
          }
          getCostByMainCurrency={getCostByMainCurrency}
          sx={{ mt: 1 }}
        />
      }
      sx={sx}
    />
  );
};

export default MetaPublisherPlatformInsightsCard;
